import enLang from './entries/en_US';
import ArLang from './entries/ar_EG';

const AppLocale = {
    en: enLang,
    ar: ArLang
};

export default AppLocale;